export default __webpack_public_path__ + "static/media/group-3-img2.67546177.png";